import type { TNature } from 'constants/types';

const NATURES: TNature[] = [
  {
    nature: 'Hardy',
    increased: '—',
    decreased: '—',
    value: 'Hardy',
    key: 'Hardy',
    text: 'Hardy',
  },
  {
    nature: 'Lonely',
    increased: 'Attack',
    decreased: 'Defense',
    value: 'Lonely',
    key: 'Lonely',
    text: 'Lonely',
  },
  {
    nature: 'Brave',
    increased: 'Attack',
    decreased: 'Speed',
    value: 'Brave',
    key: 'Brave',
    text: 'Brave',
  },
  {
    nature: 'Adamant',
    increased: 'Attack',
    decreased: 'Sp. Attack',
    value: 'Adamant',
    key: 'Adamant',
    text: 'Adamant',
  },
  {
    nature: 'Naughty',
    increased: 'Attack',
    decreased: 'Sp. Defense',
    value: 'Naughty',
    key: 'Naughty',
    text: 'Naughty',
  },
  {
    nature: 'Bold',
    increased: 'Defense',
    decreased: 'Attack',
    value: 'Bold',
    key: 'Bold',
    text: 'Bold',
  },
  {
    nature: 'Docile',
    increased: '—',
    decreased: '—',
    value: 'Docile',
    key: 'Docile',
    text: 'Docile',
  },
  {
    nature: 'Relaxed',
    increased: 'Defense',
    decreased: 'Speed',
    value: 'Relaxed',
    key: 'Relaxed',
    text: 'Relaxed',
  },
  {
    nature: 'Impish',
    increased: 'Defense',
    decreased: 'Sp. Attack',
    value: 'Impish',
    key: 'Impish',
    text: 'Impish',
  },
  {
    nature: 'Lax',
    increased: 'Defense',
    decreased: 'Sp. Defense',
    value: 'Lax',
    key: 'Lax',
    text: 'Lax',
  },
  {
    nature: 'Timid',
    increased: 'Speed',
    decreased: 'Attack',
    value: 'Timid',
    key: 'Timid',
    text: 'Timid',
  },
  {
    nature: 'Hasty',
    increased: 'Speed',
    decreased: 'Defense',
    value: 'Hasty',
    key: 'Hasty',
    text: 'Hasty',
  },
  {
    nature: 'Serious',
    increased: '—',
    decreased: '—',
    value: 'Serious',
    key: 'Serious',
    text: 'Serious',
  },
  {
    nature: 'Jolly',
    increased: 'Speed',
    decreased: 'Sp. Attack',
    value: 'Jolly',
    key: 'Jolly',
    text: 'Jolly',
  },
  {
    nature: 'Naive',
    increased: 'Speed',
    decreased: 'Sp. Defense',
    value: 'Naive',
    key: 'Naive',
    text: 'Naive',
  },
  {
    nature: 'Modest',
    increased: 'Sp. Attack',
    decreased: 'Attack',
    value: 'Modest',
    key: 'Modest',
    text: 'Modest',
  },
  {
    nature: 'Mild',
    increased: 'Sp. Attack',
    decreased: 'Defense',
    value: 'Mild',
    key: 'Mild',
    text: 'Mild',
  },
  {
    nature: 'Quiet',
    increased: 'Sp. Attack',
    decreased: 'Speed',
    value: 'Quiet',
    key: 'Quiet',
    text: 'Quiet',
  },
  {
    nature: 'Bashful',
    increased: '—',
    decreased: '—',
    value: 'Bashful',
    key: 'Bashful',
    text: 'Bashful',
  },
  {
    nature: 'Rash',
    increased: 'Sp. Attack',
    decreased: 'Sp. Defense',
    value: 'Rash',
    key: 'Rash',
    text: 'Rash',
  },
  {
    nature: 'Calm',
    increased: 'Sp. Defense',
    decreased: 'Attack',
    value: 'Calm',
    key: 'Calm',
    text: 'Calm',
  },
  {
    nature: 'Gentle',
    increased: 'Sp. Defense',
    decreased: 'Defense',
    value: 'Gentle',
    key: 'Gentle',
    text: 'Gentle',
  },
  {
    nature: 'Sassy',
    increased: 'Sp. Defense',
    decreased: 'Speed',
    value: 'Sassy',
    key: 'Sassy',
    text: 'Sassy',
  },
  {
    nature: 'Careful',
    increased: 'Sp. Defense',
    decreased: 'Sp. Attack',
    value: 'Careful',
    key: 'Careful',
    text: 'Careful',
  },
  {
    nature: 'Quirky',
    increased: '—',
    decreased: '—',
    value: 'Quirky',
    key: 'Quirky',
    text: 'Quirky',
  },
];
export default NATURES;
